import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Group,
  Select,
  SelectProps,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useDebouncedState } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconAdjustmentsCog,
  IconBrandBootstrap,
  IconCalendar,
  IconCheck,
  IconClipboardX,
  IconEdit,
  IconListCheck,
  IconPrinter,
  IconSearch,
  IconStatusChange,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useState } from "react";
import { useReactToPrint } from "react-to-print";
import {
  _timerDelayClick,
  repositoryDelivery,
  repositoryMdm,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { paginationBase } from "../../../_base/model/_base/BaseTable";
import { AvatarUtils } from "../../../common/ColorByName/AvatarUtils";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../../common/FormatDate/FormatDate";
import { _localization } from "../../../config/location";
import { green } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import { TblWarrantyServiceRequestFormDetail } from "../../../model/TblWarrantyServiceRequestForm";
import "../../../Styles/tab.component.css";
import PrinterRequestReceiptForm from "../ReceiveWarranty/PrinterRequestReceiptForm";
import AssignmentAtHome from "./AssignmentAtHome";
import DetailProductWarranty from "./DetailProductWarranty";
import RemoteProcessing from "./RemoteProcessing";
import UpdateWarrantyAssignment from "./UpdateWarrantyAssignment";
import WarrantyAssignment from "./WarrantyAssignment";
import { useLocation, useNavigate } from "react-router-dom";

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const ProcessingAssignment = () => {
  //data and fetching state
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any[]>([]);
  const [, setDataTemp] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [pagination, setPagination] = useState(paginationBase);
  const [dataTblBranch, setDataTblBranch] = useState<any[]>([]);
  // const [listItemId, setListItemId] = useState<any[]>([]);
  const [dataRequestFormSelect, setDataRequestFormSelect] = useState<any[]>([]);
  //table state
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [selectProcessingMethod, setSelectProcessingMethod] = useState<
    string | null
  >(null);
  const [selectItemStatus, setSelectItemStatus] = useState<string | null>(null);
  const [selectEmpNameInCharge, setSelectEmpNameInCharge] = useState<
    string | null
  >(null);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const componentRef = React.useRef(null);
  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    pageStyle: `
        @page {
          size:auto;
          margin: 5mm 0;
      }`,
  });
  const [dataPrint, setDataPrint] = useState<any>();
  //count
  const [timeLeft, setTimeLeft] = useState(60);
  const [isCounting, setIsCounting] = useState(false);
  //search
  const navigate = useNavigate();
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  const [search, setSearch] = useState<any>({
    startDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.startDate
        : new Date(
            new Date(new Date().setMonth(new Date().getMonth() - 1)).getTime() +
              7 * 60 * 60 * 1000,
          )?.toISOString(),
    endDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.endDate
        : new Date(new Date().getTime() + 7 * 60 * 60 * 1000)?.toISOString(),
    status: _searchJson && checkedPinSearch ? _searchJson?.status : "",
    processingMethod:
      _searchJson && checkedPinSearch ? _searchJson?.processingMethod : "",
    employeeIncharge:
      _searchJson && checkedPinSearch ? _searchJson?.employeeIncharge : "",
    custId: _searchJson && checkedPinSearch ? _searchJson?.custId : "",
    branch: _searchJson && checkedPinSearch ? _searchJson?.branch : "",
  });

  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300,
  );

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "requestNum",
        header: "Số phiếu yêu cầu",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue, cell }) => (
          <Badge
            radius="sm"
            variant="dot"
            size="lg"
            color={renderedCellValue === null ? "red" : green.base}
          >
            {renderedCellValue === null ? null : renderedCellValue}
          </Badge>
        ),
        size: 225,
      },
      {
        accessorKey: "attribute18",
        header: "Số phiếu tiếp nhận hàng lỗi",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        size: 250,
        Cell: ({ renderedCellValue, cell }) => (
          <Badge
            radius="sm"
            variant="dot"
            size="lg"
            color={renderedCellValue === null ? "red" : green.base}
          >
            {renderedCellValue === null ? "Chưa lập phiếu" : renderedCellValue}
          </Badge>
        ),
      },
      {
        accessorKey: "branchId",
        header: "Nơi nhận yêu cầu",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        Cell: ({ row }: any) => (
          <Text size="12.5px" fw={"500"}>
            {
              dataTblBranch.find(
                (i: any) =>
                  String(i.id) === String(row.original.branchId || ""),
              )?.name
            }
          </Text>
        ),
      },
      {
        accessorKey: "priority",
        header: "Độ ưu tiên",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <Badge color={getColorPriority(row.original.priority)} radius={"sm"}>
            {row.original.priority}
          </Badge>
        ),
      },
      {
        accessorKey: "custMeeting",
        header: "Khách hàng hẹn gặp",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        size: 200,
        Cell: ({ row }) => <AvatarUtils value={row.original.custMeeting} />,
      },
      {
        accessorKey: "custPhone",
        header: "SĐT",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "meetingAddress",
        header: "Địa chỉ hẹn gặp",
        Cell: ({ renderedCellValue, row }: any) => (
          <Text fw={"500"} size="12.5px">
            {row.original.additionalAddress !== null
              ? `${row.original.additionalAddress} - ${renderedCellValue}`
                  .replace(/\s*-\s*-\s*/g, " - ")
                  .replace(/^\s*-\s*/, "")
              : `${renderedCellValue}`.replace(/^\s*-\s*/, "")}{" "}
          </Text>
        ),
        enableSorting: false,
        enableColumnActions: true,
        enableColumnFilter: false,
        size: 550,
      },
      {
        accessorKey: "processingMethodName",
        header: "Hình thức xử lý",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        size: 150,
        Cell: ({ row }) => (
          <Badge
            color={getColorProcessingMethod(row.original.processingMethodName)}
            radius={"sm"}
          >
            {row.original.processingMethodName}
          </Badge>
        ),
        filterFn: "equals",
        mantineFilterSelectProps: {
          data: [
            { label: "Xử lý tại nhà", value: "Xử lý tại nhà" },
            { label: "Xử lý tại CH/CN", value: "Xử lý tại CH/CN" },
            { label: "Hãng xử lý", value: "Hãng xử lý" },
            { label: "Xử lý trực tiếp", value: "Xử lý trực tiếp" },
            { label: "Xử lý từ xa", value: "Xử lý từ xa" },
          ],
        },
        filterVariant: "select",
      },
      {
        accessorKey: "empnameincharge",
        header: "Người nhận phân công",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
        Cell: ({ row }) => <AvatarUtils value={row.original.empnameincharge} />,
        size: 250,
      },
      {
        accessorKey: "requestStatus",
        header: "Trạng thái",
        Cell: ({ row }) => (
          <>
            <Badge
              radius={"sm"}
              color={getColorStatus(row.original.requestStatus?.toString())}
              variant="light"
              bd={`1px solid ${getColorStatus(
                row.original.requestStatus?.toString(),
              )}`}
            >
              {getValueStatus(row.original.requestStatus) ?? "Không xác định"}
            </Badge>
          </>
        ),
        enableSorting: false,
        enableColumnActions: true,
        enableColumnFilter: false,
      },
      {
        accessorKey: "meetingDate",
        header: "Ngày hẹn",
        enableColumnActions: true,
        enableSorting: false,
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
        enableColumnFilter: false,
      },
      {
        accessorKey: "createDate",
        header: "Ngày tiếp nhận",
        enableColumnActions: true,
        enableSorting: false,
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
        enableColumnFilter: false,
      },
      {
        accessorKey: "content",
        header: "Nội dung",
        enableColumnActions: true,
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableSorting: false,
        enableColumnActions: true,
        enableColumnFilter: false,
        enableResizing: false,
        Cell: ({ row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Tooltip label="Chỉnh sửa phân công">
              <ActionIcon
                variant="light"
                color="orange"
                onClick={() =>
                  modalUpdateWarrantyAssign(row.original.id, row.original)
                }
                disabled={
                  row.original.processingMethodName === "Hãng xử lý" ||
                  row.original.requestStatus !== "DA_PHAN_CONG"
                }
              >
                <IconEdit size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Cập nhật bảo hành">
              <ActionIcon
                variant="light"
                color="teal"
                onClick={() =>
                  modalRemoteProcessing(
                    row.original.id,
                    row.original.requestStatus,
                    row.original.processingMethod,
                  )
                }
                disabled={
                  row.original.requestStatus === "DA_XU_LY" ||
                  row.original.requestStatus === "TRA_KHACH" ||
                  ((row.original.requestStatus === "CHO_PHAN_CONG" ||
                    row.original.requestStatus === "HUY_PHAN_CONG") &&
                    row.original.processingMethodName === "Xử lý tại nhà")
                }
              >
                <IconListCheck size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Hủy phân công">
              <ActionIcon
                variant="light"
                color="red"
                onClick={() => handleCancelAssign([row.original.id])}
                disabled={
                  row.original.requestStatus === "HUY_PHAN_CONG" ||
                  row.original.requestStatus === "CHO_PHAN_CONG" ||
                  row.original.processingMethodName === "Hãng xử lý" ||
                  row.original.requestStatus === "DANG_XU_LY" ||
                  row.original.requestStatus === "DA_XU_LY" ||
                  row.original.requestStatus === "TRA_KHACH"
                }
              >
                <IconClipboardX size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="In phiếu">
              <ActionIcon
                variant="light"
                color="blue"
                onClick={() => {
                  setDataPrint({
                    ...row.original,
                    companyCode: dataTblBranch.find(
                      (i: any) =>
                        String(i.id) === String(row.original.branchId || ""),
                    )?.companyCode,
                  });
                  setTimeout(() => {
                    handlePrint();
                  }, 500);
                }}
                disabled={row.original.requestStatus === "CHO_PHAN_CONG"}
              >
                <IconPrinter size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Box>
        ),
      },
    ],
    [selectProcessingMethod, dataTblBranch, dataPrint],
  );

  const startCountdown = () => {
    if (!isCounting) {
      setTimeLeft(_timerDelayClick);
      setIsCounting(true);
    }
  };

  function getColorProcessingMethod(value: string) {
    switch (value) {
      case "Xử lý tại nhà":
        return "lime";
      case "Hãng xử lý":
        return "green";
      case "Xử lý trực tiếp":
        return "teal";
      case "Xử lý tại CH/CN":
        return "cyan";
      case "Xử lý từ xa":
        return "orange";
      case "":
      case null:
        return "rgba(255, 255, 255, 0)";
    }
  }

  function getColorStatus(status: string) {
    switch (status) {
      case "DA_PHAN_CONG":
      case "DA_XU_LY":
      case "HANG_DA_XU_LY":
      case "TRA_KHACH":
        return "#4CAF50";

      case "CHO_PHAN_CONG":
      case "XU_LY_LAI":
      case "HANG_DANG_XU_LY":
      case "CHUA_XU_LY":
        return "#d9d02f";

      case "HUY_PHAN_CONG":
      case "KY_THUAT_HUY":
        return "#F44336";

      case "HANG_XU_LY":
        return "#2196F3";

      case "DANG_XU_LY":
        return "#FF9800";

      case "":
      case null:
        return "rgba(255, 255, 255, 0)";

      default:
        return "#424242";
    }
  }

  function getValueStatus(value: string) {
    switch (value) {
      case "CHO_PHAN_CONG":
        return "Chờ phân công";
      case "HUY_PHAN_CONG":
        return "Hủy phân công";
      case "DA_PHAN_CONG":
        return "Đã phân công";
      case "XU_LY_LAI":
        return "Xử lý lại";
      case "KY_THUAT_HUY":
        return "Kỹ thuật hủy";
      case "HANG_XU_LY":
        return "Hãng xử lý";
      case "HANG_DANG_XU_LY":
        return "Hãng đang xử lý";
      case "DANG_XU_LY":
        return "Đang xử lý";
      case "DA_XU_LY":
        return "Đã xử lý";
      case "TRA_KHACH":
        return "Trả khách";
    }
  }

  function getColorPriority(value: string | null) {
    switch (value) {
      case "Cao":
        return "#f21616";
      case "Thấp":
        return "#6bd731";
      case null:
      case "":
        return "rgba(255, 255, 255, 0)";
    }
  }

  const handleAssignmentProcessing = () => {
    if (selectProcessingMethod === "Xử lý tại nhà") {
      modalAssignAtHome();
    } else if (
      selectProcessingMethod === "Xử lý từ xa" ||
      selectProcessingMethod === "Xử lý tại CH/CN" ||
      selectProcessingMethod === "Xử lý trực tiếp"
    ) {
      modalWarrantyAssignment();
    }
  };

  const optionColorProcessingMethod: Record<
    | "Xử lý tại nhà"
    | "Xử lý tại CH/CN"
    | "Hãng xử lý"
    | "Xử lý trực tiếp"
    | "Xử lý từ xa",
    string
  > = {
    "Xử lý tại nhà": "lime",
    "Xử lý tại CH/CN": "cyan",
    "Hãng xử lý": "green",
    "Xử lý trực tiếp": "teal",
    "Xử lý từ xa": "orange",
  };

  const renderSelectOptionProcessingMethod: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorProcessingMethod[
            option.label as
              | "Xử lý tại nhà"
              | "Xử lý tại CH/CN"
              | "Hãng xử lý"
              | "Xử lý trực tiếp"
              | "Xử lý từ xa"
          ]
        }
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  const optionColorsStatus: Record<
    | "Chờ phân công"
    | "Hủy phân công"
    | "Đã phân công"
    | "Hãng đang xử lý"
    | "Kỹ thuật hủy"
    | "Đã xử lý"
    | "Xử lý lại"
    | "Hãng xử lý"
    | "Đang xử lý"
    | "Trả khách",
    string
  > = {
    "Chờ phân công": "#d9d02f",
    "Hủy phân công": "#F44336",
    "Đã phân công": "#4CAF50",
    "Hãng đang xử lý": "#FF9800",
    "Kỹ thuật hủy": "#F44336",
    "Đã xử lý": "#4CAF50",
    "Xử lý lại": "#d9d02f",
    "Hãng xử lý": "#2196F3",
    "Đang xử lý": "#FF9800",
    "Trả khách": "#4CAF50",
  };

  const renderSelectOptionStatus: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorsStatus[
            option.label as
              | "Chờ phân công"
              | "Hủy phân công"
              | "Đã phân công"
              | "Hãng đang xử lý"
              | "Kỹ thuật hủy"
              | "Đã xử lý"
              | "Xử lý lại"
          ]
        }
        radius="sm"
        variant="light"
        bd={`1px solid ${
          optionColorsStatus[
            option.label as
              | "Chờ phân công"
              | "Hủy phân công"
              | "Đã phân công"
              | "Hãng đang xử lý"
              | "Kỹ thuật hủy"
              | "Đã xử lý"
              | "Xử lý lại"
          ]
        }`}
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  const handleChangeSearchValue = (value: string, key: string) => {
    if (value !== "Invalid date")
      setSearch((prevData: any) => ({ ...prevData, [key]: value }));
    else {
      setSearch((prevData: any) => ({ ...prevData, [key]: "" }));
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);

    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;

    if (search.startDate) {
      url += `&StartDate=${search.startDate}`;
    }

    if (search.endDate) {
      url += `&EndDate=${search.endDate}`;
    }

    if (search.processingMethod) {
      url += `&ProcessingMethod=${search.processingMethod}`;
    }

    if (search.status) {
      url += `&RequestStatus=${search.status}`;
    }

    if (search.employeeIncharge) {
      url += `&EmployeeIncharge=${search.employeeIncharge}`;
    }

    if (search.custId) {
      url += `&CustId=${search.custId}`;
    }

    if (search.branch) {
      url += `&BranchId=${search.branch}`;
    }

    if (keySearch) {
      url += `&KeySearch=${keySearch?.trim()}`;
    }

    try {
      const response = await repositoryMdm.get<
        MessageResponse<TblWarrantyServiceRequestFormDetail[]>
      >(`api/v1/TblWarrantyServiceRequestForm/get-list-v2${url}`);
      if (response && response.success) {
        let result = response.data;
        setData(result);
        setDataTemp(response.data);
        setRowCount(response.totalCount ?? 0);
        setSelectIds([]);
        table.resetRowSelection();
        await Promise.all([dataBranchSelect()]);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    }
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
    sessionStorage.setItem(
      String(location.pathname),
      JSON.stringify({
        ...search,
        keySearch: keySearch,
      }),
    );
    startCountdown();
  };

  const handleCancelAssign = async (ids: string[] | number[]) => {
    const res = await repositoryMdm.post<MessageResponse<any>>(
      "/api/v1/TblWarrantyServiceRequestForm/cancel-assignment",
      ids,
    );

    if (res && res?.success) {
      NotificationExtension.Success("Hoàn tất hủy phân công !");
      setTimeout(() => {
        fetchData();
      }, 500);
    }
  };

  const dataBranchSelect = async () => {
    const res = await repositoryDelivery.get<MessageResponse<any>>(
      "/api/v1/TblDmMasterOrg/get-all",
    );

    if (res && res.success) {
      const result = res.data;
      setDataTblBranch(result);
    }
  };

  function modalRemoteProcessing(
    id: number | string,
    status: string | null,
    processing: string,
  ) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Cập nhật thông tin bảo hành sản phẩm</Title>
        </>
      ),
      size: "auto",
      children: (
        <RemoteProcessing
          id={id}
          onClose={setDeleteViewStatus}
          status={status}
          processing={processing}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function modalAssignAtHome() {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Phân công xử lý tại nhà</Title>
        </>
      ),
      size: "auto",
      children: (
        <AssignmentAtHome
          selectIds={selectIds}
          onClose={setDeleteViewStatus}
          dataRequestFormSelect={dataRequestFormSelect}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function modalWarrantyAssignment() {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Phân công nhân viên bảo hành</Title>
        </>
      ),
      size: "auto",
      children: (
        <WarrantyAssignment
          dataRequestFormSelect={dataRequestFormSelect}
          selectIds={selectIds}
          onClose={setDeleteViewStatus}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function modalUpdateWarrantyAssign(
    id: number | string,
    dataRequestForm: any,
  ) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chỉnh sửa phân công nhân viên bảo hành</Title>
        </>
      ),
      size: "auto",
      children: (
        <UpdateWarrantyAssignment
          id={id}
          onClose={setDeleteViewStatus}
          dataRequestFormSelect={dataRequestForm}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>;
    if (isCounting && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setIsCounting(false);
    }
    return () => clearInterval(timer);
  }, [isCounting, timeLeft]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    fetchData();
  }, [pagination, deleteViewStatus]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (170 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, [height]);

  useEffect(() => {
    if (selectIds.length > 0) {
      const lastId = selectIds[selectIds.length - 1];
      const foundData = data.find((p) => p.id.toString() === lastId);

      if (foundData) {
        setSelectProcessingMethod(foundData.processingMethodName);
        setSelectItemStatus(foundData.requestStatus);
        setSelectEmpNameInCharge(foundData.empnameincharge);
      } else {
        setSelectProcessingMethod(null);
        setSelectItemStatus(null);
        setSelectEmpNameInCharge(null);
      }
    } else {
      setSelectProcessingMethod(null);
      setSelectItemStatus(null);
      setSelectEmpNameInCharge(null);
    }
  }, [selectIds]);

  useEffect(() => {
    const numericIds = selectIds.map((id) => Number(id));

    const filtered = data.filter((item) =>
      numericIds.includes(Number(item.id)),
    );

    setDataRequestFormSelect(filtered);
  }, [selectIds, data]);

  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem(
      "columnPinningProcessingAssignment",
    );
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : {
          left: ["mrt-row-select", "requestNum"],
          right: ["processingMethodName", "action"],
        }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage(),
  );

  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem(
      "columnPinningProcessingAssignment",
      JSON.stringify(columnPinning),
    );
  }, [columnPinning]);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    positionToolbarAlertBanner: "bottom",
    columnFilterDisplayMode: "popover",
    enableRowSelection: (row) => {
      if (selectProcessingMethod === null || selectProcessingMethod === "") {
        return true;
      } else {
        return row.original.processingMethodName === selectProcessingMethod;
      }
    },
    //add custom action buttons to top-left of top toolbar
    renderTopToolbarCustomActions: ({ row }: any) => (
      <div ref={headerRef} style={{ width: "100%" }}>
        <Flex justify={"space-between"} wrap={"wrap"}>
          <_breadcrumb></_breadcrumb>
          <Flex
            gap="md"
            justify="flex-end"
            align="center"
            direction="row"
            wrap="wrap"
          >
            <Button
              color="violet"
              disabled={
                selectProcessingMethod === "Hãng xử lý" ||
                selectIds.length === 0 ||
                (selectItemStatus !== "CHO_PHAN_CONG" &&
                  selectItemStatus !== "HUY_PHAN_CONG" &&
                  selectEmpNameInCharge !== null)
              }
              onClick={() => handleAssignmentProcessing()}
              w={115}
            >
              Phân công
            </Button>
            <Button
              color="red"
              disabled={
                selectItemStatus === "CHO_PHAN_CONG" ||
                selectProcessingMethod === "Hãng xử lý" ||
                selectItemStatus === "HUY_PHAN_CONG" ||
                selectIds.length === 0
              }
              leftSection={<IconClipboardX size={20} />}
              onClick={() => handleCancelAssign(selectIds)}
            >
              Hủy phân công
            </Button>
          </Flex>
        </Flex>
        <Grid mt={10}>
          <Grid.Col span={{ base: 12, md: 6, lg: 1.8 }}>
            <DatePickerInput
              size="sm"
              placeholder="Từ ngày"
              leftSection={<IconCalendar color="#15aabf" />}
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.startDate && search.startDate.length > 0
                  ? new Date(search.startDate)
                  : null
              }
              maxDate={
                search.endDate && search.endDate?.length > 0
                  ? new Date(search.endDate)
                  : new Date()
              }
              onChange={(e) => {
                handleChangeSearchValue(
                  formatDateNotTimeZone(e) ?? "",
                  "startDate",
                );
              }}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 1.8 }}>
            <DatePickerInput
              size="sm"
              placeholder="Đến ngày"
              leftSection={<IconCalendar color="#15aabf" />}
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.endDate && search.endDate.length > 0
                  ? new Date(search.endDate)
                  : null
              }
              minDate={
                search.startDate && search.startDate?.length > 0
                  ? new Date(search.startDate)
                  : undefined
              }
              onChange={(e) => {
                handleChangeSearchValue(
                  formatDateNotTimeZone(e) ?? "",
                  "endDate",
                );
              }}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 1.8 }}>
            <Select
              placeholder="Chi nhánh"
              searchable
              clearable
              value={search.branch || null}
              data={dataTblBranch?.map((i) => ({
                label: `${i.code} - ${i.name}`,
                value: String(i.id),
              }))}
              leftSection={<IconBrandBootstrap color="#15aabf" />}
              onChange={(e) =>
                handleChangeSearchValue(e?.toString() ?? "", "branch")
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 1.8 }}>
            <Select
              placeholder="Trạng thái"
              data={[
                { label: "Chờ phân công", value: "CHO_PHAN_CONG" },
                { label: "Đã phân công", value: "DA_PHAN_CONG" },
                { label: "Hủy phân công", value: "HUY_PHAN_CONG" },
                { label: "Đang xử lý", value: "DANG_XU_LY" },
                { label: "Đã xử lý", value: "DA_XU_LY" },
                { label: "Hãng xử lý", value: "HANG_XU_LY" },
                { label: "Hãng đang xử lý", value: "HANG_DANG_XU_LY" },
                { label: "Hãng đã xử lý", value: "HANG_DA_XU_LY" },
                { label: "Xử lý lại", value: "XU_LY_LAI" },
                { label: "Trả khách", value: "TRA_KHACH" },
              ]}
              leftSection={<IconStatusChange color="#15aabf" />}
              clearable
              value={search.status || null}
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              onChange={(e) =>
                handleChangeSearchValue(e?.toString() ?? "", "status")
              }
              renderOption={renderSelectOptionStatus}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 1.8 }}>
            <Select
              placeholder="Hình thức xử lý"
              data={[
                { label: "Xử lý tại nhà", value: "XLTN" },
                { label: "Xử lý tại CH/CN", value: "XLCN" },
                { label: "Hãng xử lý", value: "HXL" },
                { label: "Xử lý từ xa", value: "XLTX" },
              ]}
              leftSection={<IconAdjustmentsCog color="#15aabf" />}
              value={search.processingMethod || null}
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              onChange={(e) =>
                handleChangeSearchValue(e?.toString() ?? "", "processingMethod")
              }
              renderOption={renderSelectOptionProcessingMethod}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 1.8 }}>
            <TextInput
              placeholder="Nhập từ khóa tìm kiếm"
              defaultValue={keySearch}
              leftSection={<IconSearch color="#15aabf" />}
              onChange={(e) => setKeySearch(e.currentTarget.value ?? "")}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 1.2 }}>
            <Button
              variant="outline"
              color="blue"
              leftSection={<IconSearch size={14} />}
              onClick={() => {
                fetchData();
              }}
              w={"100%"}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
    ),
    enableExpandAll: false,
    renderToolbarInternalActions: ({ table }) => <></>,
    renderDetailPanel: ({ row }) => (
      <DetailProductWarranty
        processingMethod={row.original.processingMethodName}
        dataDetail={row.original.tblWarrantyServiceRequestFormDetailModels}
        typeProduct={row.original.attribute6}
      />
    ),
    mantineSelectAllCheckboxProps: {
      style: {
        display: "none",
      },
    },
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        ...columnPinning,
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    onPaginationChange: setPagination,
    onRowSelectionChange: setRowSelection,
    rowCount,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
      columnPinning,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["25", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  return (
    <>
      <MantineReactTable table={table} />
      <Box display={"none"}>
        <PrinterRequestReceiptForm
          innerRef={componentRef}
          dataPrint={dataPrint}
        />
      </Box>
    </>
  );
};

export default ProcessingAssignment;
